import { yupResolver } from "@hookform/resolvers/yup";
import { PropTypes } from "prop-types";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormContainer } from "@/components";
import { contributorFormData, identifiersData, inputData } from "@/data";
import { useContributorSchema } from "@/schemas";
import { StyledTextField } from "@/styles";
import { renderFormControllerHandler } from "@/utils";

const ContributorForm = ({ action, loading, onSubmitForm, values }) => {
    const { t } = useTranslation();

    const schema = useContributorSchema();

    const formMethods = useForm({
        defaultValues: values,
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const {
        control,
        formState: { errors },
    } = formMethods;

    const { text: textInputType } = inputData.types;

    const renderFormControllerChildrenHandler = (field, label, name, type, isOptional) => {
        switch (type) {
            case textInputType:
            default:
                return (
                    <StyledTextField
                        {...field}
                        error={errors[name]}
                        helperText={errors[name] && errors[name]?.message}
                        id={`${name}_${identifiersData.ids.input}`}
                        label={isOptional ? `${t(`labels.${label}`)} (${t("labels.optional")})` : t(`labels.${label}`)}
                        variant="outlined"
                        fullWidth
                    />
                );
        }
    };

    return (
        <FormContainer
            action={action}
            formMethods={formMethods}
            loading={loading}
            data={renderFormControllerHandler(control, contributorFormData, renderFormControllerChildrenHandler)}
            onSubmitForm={onSubmitForm}
        />
    );
};

export default ContributorForm;

ContributorForm.propTypes = {
    action: PropTypes.string,
    loading: PropTypes.bool,
    onSubmitForm: PropTypes.func,
    values: PropTypes.object,
};
